import { render } from "./Support.vue?vue&type=template&id=a5fbfba2&scoped=true"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"

import "./Support.vue?vue&type=style&index=0&id=a5fbfba2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5fbfba2"]])

export default __exports__